import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import exitFullscreen from 'utils/fullScreen';
import { shouldShowVideoBlocker } from 'utils/primeUtil';
import startPlayer from './player';
import s from './Audio.scss';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

class Audio extends React.Component {
  static propTypes = {
    msid: PropTypes.string,
    chapterId: PropTypes.string,
    slikeId: PropTypes.string,
    videoClassName: PropTypes.string,
    videoClassInner: PropTypes.string,
    useSamePlayerId: PropTypes.bool,
    // title: PropTypes.string,
    // rmid: PropTypes.string,
    // livetv: PropTypes.bool,
    // autoplay: PropTypes.bool,
    blockAutoplay: PropTypes.bool,
    outsideEventListener: PropTypes.func,
    nextVideoMsidArray: PropTypes.arrayOf(PropTypes.string),
    store: PropTypes.shape({}),
    userData: PropTypes.shape({
      prcValue: PropTypes.string,
    }).isRequired,
    isPrime: PropTypes.bool,
    isUserPrime: PropTypes.bool,
    isContentPrime: PropTypes.bool,
    pos: PropTypes.string,
    playerContainerId: PropTypes.string,
    isVideoSkipAds: PropTypes.bool,
    // isDockingEnabled: PropTypes.bool,
    // addToWatched: PropTypes.func,
    source: PropTypes.string,
    allowDim: PropTypes.bool,
    videoRef: PropTypes.shape({}).isRequired,
    slikeNextVideoAutoPlayed: PropTypes.bool,
    videoDataReceivedCallback: PropTypes.func,
    asyncLoadSdkjs: PropTypes.bool,
    isWapView: PropTypes.bool,
    iphonefs: PropTypes.bool,
    isInline: PropTypes.bool,
    sectionName: PropTypes.string,
    isMute: PropTypes.bool,
    eventsCallbackMap: PropTypes.shape({}),
    isAudioSummary: PropTypes.bool,
  };
  static defaultProps = {
    // livetv: false,
    // autoplay: false,
    // title: '',
    blockAutoplay: false,
    msid: '',
    useSamePlayerId: false,
    chapterId: undefined,
    videoClassName: '',
    videoClassInner: '',
    slikeNextVideoAutoPlayed: false,
    // rmid: '',
    outsideEventListener: undefined,
    nextVideoMsidArray: [],
    store: {},
    // rmid: '',
    slikeId: undefined,
    pos: '0',
    isPrime: false,
    isUserPrime: false,
    isContentPrime: false,
    playerContainerId: '',
    isVideoSkipAds: false,
    // isDockingEnabled: false,
    source: '',
    allowDim: true,
    // addToWatched: undefined,
    videoDataReceivedCallback: undefined,
    asyncLoadSdkjs: false,
    isWapView: false,
    iphonefs: false,
    isInline: false,
    sectionName: '',
    isMute: false,
    eventsCallbackMap: {},
    isAudioSummary: false,
  };
  constructor() {
    super();
    this.isPlaying = false;
    this.primeEndDate = '';
    this.slikeInstance = null;
    this.state = {
      audioLoaded: false,
    };
    this.intantiateNewPlayer = true;
  }

  componentDidMount() {
    // if (this.props.autoplay) {
    //   this.startVideo(
    //     this.props.msid,
    //     Audio.getDivId(this.props.msid, this.props.isInline),
    //     this.props.chapterId,
    //   );
    //   this.isPlaying = true;
    // }
    // this.processPrimeBlocker();
    this.startAudio(
      this.props.msid,
      this.getDivId(this.props.msid, this.props.isInline),
      this.props.chapterId,
    );
    this.isPlaying = true;
  }

  componentDidUpdate(prevProps, prevState) {
    const { videoContainer } = this;
    const { userData, isContentPrime } = this.props;
    const { prcValue } = userData;

    if (
      (prevProps.userData && prevProps.userData.prcValue !== prcValue) ||
      prevProps.msid !== this.props.msid
    ) {
      if (!isContentPrime || !shouldShowVideoBlocker(prcValue)) {
        this.mute(false);
      }
    }

    // Typical usage (don't forget to compare props):
    if (
      this.props.msid !== prevProps.msid &&
      !this.props.slikeNextVideoAutoPlayed
    ) {
      this.isPlaying = false;
      if (videoContainer && videoContainer.innerHTML) {
        videoContainer.innerHTML = '';
      }
      this.startAudio(
        this.props.msid,
        this.getDivId(this.props.msid, this.props.isInline),
      );
    }

    if (prevState.activeSlide !== this.state.activeSlide) {
      this.startAudio(
        this.state.activeSlide,
        this.getDivId(this.props.playerContainerId, this.props.isInline),
      );
    }

    // if (
    //   prevState.isLeadVideoTheatreOpen !== this.state.isLeadVideoTheatreOpen
    // ) {
    //   const body = document.getElementsByTagName('body')[0];
    //   body.style.overflow = this.state.isLeadVideoTheatreOpen ? 'hidden' : '';
    // }
  }

  handleSliderCardItem = (e, clickedVideoItem) => {
    e.preventDefault();
    this.setState({
      // playingVideoItem: clickedVideoItem,
      activeSlide: clickedVideoItem.id,
    });
  };

  videoEventsListener = (eventOrigin, eventObj) => {
    if (typeof this.props.outsideEventListener === 'function') {
      this.props.outsideEventListener(eventOrigin, eventObj);
    }
  };

  showPrimeBlocker = (data = {}) => {
    this.primeEndDate = data.data && data.data.endDate ? data.data.endDate : '';
    exitFullscreen();
  };

  mute = shouldMute => {
    if (this.slikeInstance && typeof this.slikeInstance.mute === 'function') {
      try {
        this.slikeInstance.mute(shouldMute);
      } catch (e) {
        // console.log(e);
      }
    }
  };

  pause = () => {
    if (this.slikeInstance && typeof this.slikeInstance.pause === 'function') {
      this.slikeInstance.pause();
    }
  };

  resumePlay = () => {
    if (this.slikeInstance && typeof this.slikeInstance.play === 'function') {
      this.slikeInstance.play();
    }
  };

  startAudio = (msid, divId, chapterId) => {
    this.isPlaying = true;
    const { userData, sectionName, isMute = false } = this.props;
    const { prcValue } = userData;
    if (
      typeof window.player === 'object' &&
      typeof window.player.destroy === 'function'
    ) {
      try {
        window.player.destroy();
        document.getElementById(divId).innerHTML = '';
      } catch (e) {
        // console.error(e);
      }
    }
    startPlayer({
      videoMsid: msid,
      isPodcast: true,
      divId,
      outsideEventListener: this.videoEventsListener,
      nextVideoMsidArray: this.props.nextVideoMsidArray,
      store: this.props.store,
      isPrime: this.props.isPrime,
      isUserPrime: this.props.isUserPrime,
      slikeId: this.props.slikeId,
      // livetv: this.props.livetv,
      isVideoSkipAds: this.props.isVideoSkipAds,
      sourceVal: this.props.source || 'podcast',
      allowDimVal: this.props.allowDim,
      // shouldShowVideoBlocker,
      prcValue,
      isWapView: this.props.isWapView,
      // autoPlayLeadVideo: this.props.autoPlayLeadVideo,
      callback: () => {
        // this.setState({ audioLoaded: true });
      },
      callbackOutside: inst => {
        this.slikeInstance = inst;
        this.setState({ audioLoaded: true });
      },
      muteOnLoad: isMute,
      videoDataReceivedCallback: this.props.videoDataReceivedCallback,
      asyncLoadSdkjs: this.props.asyncLoadSdkjs,
      videoChapterId: chapterId,
      iphonefs: this.props.iphonefs,
      sectionName,
      eventsCallbackMap: this.props.eventsCallbackMap,
      intantiateNewPlayer: this.intantiateNewPlayer,
      autoPlay: !this.props.isContentPrime && !this.props.blockAutoplay,
    });

    if (this.props.useSamePlayerId && !this.intantiateNewPlayer) {
      this.intantiateNewPlayer = false;
    }

    // this.setState({ isVideoPlaying: true });
  };

  getDivId = (playerContainerId, isInline) => {
    if (
      !this.props.useSamePlayerId &&
      playerContainerId &&
      playerContainerId.length
    ) {
      return `playerContainer_${playerContainerId}${isInline ? '_inline' : ''}`;
    }
    return `playerContainer`;
  };
  render() {
    const {
      // msid,
      videoClassName,
      videoClassInner,
      isAudioSummary,
      // title,
      // autoplay,
    } = this.props;
    // mobile code start<b
    const divId = this.getDivId(this.props.msid, this.props.isInline);

    // mobile code end

    return (
      <>
      <div
        ref={this.props.videoRef}
        className={`${videoClassName} ${isAudioSummary ? s.audioPlayer : ''}`}
      >
       
          {!this.state.audioLoaded &&
            isAudioSummary && <LoaderSpinner overwriteLoader={s.audioLoader} />}
          {this.state.audioLoaded &&
            isAudioSummary && (
              <div className={s.audioPlayerInner}>
                <strong>Listen to Summary</strong>
              </div>
            )}
          <div
            // onClick={() => {
            //   if (!autoplay && !this.playerInitiated) {
            //     this.playerInitiated = true;
            //   }
            // }}
            id={divId}
            data-pos={this.props.pos}
            className={`playerContainer __sast ${videoClassInner} ${
              isAudioSummary ? s.audioPlayerContainer : ''
            }`}
            style={{
              height: '100%',
            }}
          >
            {/* {title && (
            <p>
              <b>Test Audio</b>
            </p>
          )} */}
          </div>

       
      </div>
       <div className={s.audioSummaryDisclaimer}>
       <i /> AI-generated audio summary; not verified by the edit team.
     </div>
      </>
      
    );
  }
}

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
  isWapView: _get(state, 'isMobile', false),
});

export default connect(mapStateToProps)(Audio);
